import React, { useEffect, useState } from "react";
import { DKButton, DKLabel } from "deskera-ui-library";
import { ADD_LOCATION_FIELDS } from "../add-employee/steps/Employee";
import Utility, { deepClone } from "../../utility/Utility";
import TenantManager from "../../managers/TenantManager";
import RouteManager from "../../managers/RouteManager";
import { COUNTRY, IN_STATES, US_STATES } from "../../constants/CountryConstant";
import { DKInput, showToast, TOAST_TYPE, showLoader, removeLoader } from "deskera-ui-library";
import { isViewportLarge } from "../../utility/ViewportSizeUtils";
import LocationListService from "../../services/LocationListService";
import { showAddColumnPopup } from "../common/AddColumnPopup";
import { CONSTANTS } from "../../constants/Constant";
import { fetchLocationList } from "../../Redux/Slices/LocationListSlice";
import { useDispatch } from "react-redux";
const AddEditLocation = (props) => {

    const [locationInitialColumnConfig, setLocationInitialColumnConfig] = useState(deepClone(ADD_LOCATION_FIELDS));
    const [locationColumnConfig, setLocationColumnConfig] = useState(
      locationInitialColumnConfig
    );
    const { tenant } = TenantManager.getPeopleTenantData();
    const [tenantData, setTenantData] = useState(tenant);
    const [countryCode, setCountryCode] = useState("-1");
    const [defaultValue, setDefaultValues] = useState({});
    const [isEdit, setIsEdit] = useState(props.isEdit);
    const [locationData, setEditData] = useState(isEdit ? props.data : {});

    const dispatch = useDispatch()

    useEffect(() => {
        RouteManager.setPresenter({props});
    },[])

    useEffect(() => {
        const countryCode = tenantData?.countryCode;
        setCountryCode(countryCode);
    }, [tenantData]);

    useEffect(() => {
      const columns = deepClone(locationColumnConfig);
      const stateIndex =
        columns && columns.findIndex((c) => c.columnCode === "state");
      let states = []
      if (stateIndex != -1) {
        switch (countryCode) {
          case COUNTRY.IN:
            states = IN_STATES.map((x) => {
              return {
                id: x.value,
                name: x.label,
              };
            });
            columns[stateIndex].options = states;
            break;
          case COUNTRY.US:
            states = US_STATES.map((x) => {
              return {
                id: x.value,
                name: x.label
              }
            })
            columns[stateIndex].options = states;
            break;
        }
      }
      prepareAndPopulateData(columns);
      setLocationColumnConfig(columns);
    },[countryCode]);

    const loadLocationList = async () => {
         try {
           await dispatch(fetchLocationList());
         } catch (err) {
           console.error("Error loading locations: ", err);
         }
     };

    const prepareAndPopulateData = (columns) => {
      const locationAddress = isEdit
        ? locationData?.locationDetails?.address
        : tenantData.address;
      const params = {
        label: isEdit ? locationData.name : "",
        title: isEdit ? locationData.title : "",
        address1: isEdit
          ? locationAddress.address1
          : locationAddress.addressLine1,
        address2: isEdit
          ? locationAddress.address2
          : locationAddress.addressLine2,
        city: locationAddress.city,
        postalCode: isEdit
          ? locationAddress.postalCode
          : locationAddress.zipCode,
        state: isEdit
          ? getStateValue(locationAddress.state, columns, "name")
          : getStateValue(locationAddress.state, columns, "id"),
        country: getCountryValue(locationAddress.country, columns),
        email: isEdit ? locationData.email : tenantData.emailId,
        phone: isEdit ? locationData.phone : tenantData.contactNumber,
        organization: tenantData.organizationName,
      };
      setDefaultValues(params);
    }

    const getStateValue = (selectedState, columns, key) => {
      let state = {};
      if (!Utility.isEmpty(selectedState)) {
        let fieldIndex = columns.findIndex((c) => c.columnCode === "state");
        if (fieldIndex != -1) {
          let column = columns[fieldIndex];
          let options = column.options;
          let valueIndex = options.findIndex((o) => o[key] === selectedState);
          state = valueIndex != -1 ? options[valueIndex] : {};
        }
      }
      return state;
    };

    const getCountryValue = (selectedCountry, columns) => {
      let country = {};
      if (!Utility.isEmpty(selectedCountry)) {
        let fieldIndex = columns.findIndex(
          (c) => c.columnCode === "country"
        );
        if (fieldIndex != -1) {
          let column = columns[fieldIndex];
          let options = column.options;
          let valueIndex = options.findIndex((o) => o.code === selectedCountry);
          country = valueIndex != -1 ? options[valueIndex] : {};
        }
      }
      return country;
    };


    const onChange = (value, index, object) => {
      if (value && value === " ") {
        value = value.trim();
      }
      const column = deepClone(locationColumnConfig);
      if(object.required && Utility.isEmpty(value)) {
        column[index].hasError = true;
        column[index].errMsg = `Enter a valid ${object.name}`;
      } else {
        column[index].hasError = false;
        column[index].errMsg = "";
      }
      defaultValue[object.columnCode] = value;
      setLocationColumnConfig(column)
    }

    const isValid = () => {
      let isInvalid = false;
      const columns = deepClone(locationColumnConfig);
      for (let i = 0; i < columns.length; i++) {
        let field = columns[i];
        if (
          (field.required && Utility.isEmpty(defaultValue[field.columnCode])) ||
          field.hasError
        ) {
          isInvalid = true;
          columns[i].hasError = true;
          columns[i].errMsg = `Enter a valid ${field.name}`;
          break;
        }
      }
      return { isInvalid, columns };
    };

    const prepareDataObject = () => {
      let params = {
        label: defaultValue["label"] ? defaultValue["label"] : "",
        locationDetails: {
          titleSelected: true,
          title: defaultValue["title"] ? defaultValue["title"] : "",
          companySelected: true,
          company: defaultValue["title"] ? defaultValue["title"] : "",
          addressSelected: true,
          address: {
            address1: defaultValue["address1"] ? defaultValue["address1"] : "",
            address2: null,
            country: defaultValue["country"]
              ? defaultValue["country"]?.code
              : "",
            state: defaultValue["state"] ? defaultValue["state"].name : "",
            city: defaultValue["city"] ? defaultValue["city"] : "",
            postalCode: defaultValue["postalCode"]
              ? defaultValue["postalCode"]
              : "",
            preferred: null,
          },
          emailSelected: true,
          email: defaultValue["email"] ? defaultValue["email"] : "",
          phoneSelected: true,
          phone: defaultValue["phone"] ? defaultValue["phone"] : "",
        },
      };
      return params;
    };

    const onSaveClick = () => {
      let { isInvalid, columns } = isValid();
      if (isInvalid) {
        setLocationColumnConfig(columns);
        return;
      }
      let parameters = prepareDataObject();
      if (isEdit) {
        parameters["id"] = locationData?.id;
        parameters["active"] = true;
        updateLocation(parameters);
      } else {
        saveLocation(parameters);
      }
    };

    const updateLocation= (params) => {
      showLoader("Adding location...Please wait");
      LocationListService.updateLocation(params).then((res) => {
        if(res) {
          showToast(
            "Location Updated Successfully",
            TOAST_TYPE.SUCCESS
          );
          loadLocationList();
          props.onClose();
          removeLoader();
        }
      }, (error) => {
        showToast(
          "Some Unknown Error Occurred at Server. Please Try Again!",
          TOAST_TYPE.FAILURE
        );
        props.onClose();
        removeLoader();
      })
    }

    const saveLocation = (params) => {
      showLoader("Adding location...Please wait");
      LocationListService.saveLocation(params).then(
        (res) => {
          if (res) {
            showToast("Location Added Successfully", TOAST_TYPE.SUCCESS);
            loadLocationList();
            props.onClose();
            removeLoader();
          }
        },
        (error) => {
          if(error && error.code === 500) {
            showToast(`${error.errorMessage}`, TOAST_TYPE.FAILURE);
          } else {
            showToast(
              "Some Unknown Error Occurred at Server. Please Try Again!",
              TOAST_TYPE.FAILURE
            );
          }
          props.onClose();
          removeLoader();
        }
      );
    };

    const getFormFields = () => {
        return locationColumnConfig && locationColumnConfig.map((obj, index) => {
          return (
            <div
              className={`column p-h-s mb-s ${obj.width ? "" : "web-mr-l"} `}
              style={{
                width: `${
                  isViewportLarge
                    ? obj.width
                      ? `${obj.width}%`
                      : "50%"
                    : "100%"
                }`,
              }}
              key={obj.id}
            >
              <div
                className="row-responsive padding-bottom-mobile"
                style={{
                  width: `${obj.subWidth ? `${obj.subWidth}%` : "100%"}`,
                }}
              >
                <DKInput
                  title={obj.name}
                  placeholder={obj.name}
                  value={defaultValue[obj.id]}
                  className=""
                  formatter={(obj) => {
                    /** How to render a selected option in case of object **/
                    return obj.name;
                  }}
                  options={obj.options}
                  type={obj.type}
                  labelClassName=" text-align-left "
                  onChange={(value) => {
                    onChange(value, index, obj);
                  }}
                  direction={obj.direction}
                  required={obj.required}
                  readOnly={obj.readOnly}
                  canValidate={false}
                  errorMessage={`Enter a valid ${obj.name}`}
                  onClick={() => {
                    // if (index === contactFormfields.length - 1) {
                    //   // scrollToBottom();
                    // }
                  }}
                  dropdownConfig={{
                    className: "",
                    style: {},
                    allowSearch:
                      obj.options && obj.options.length > 6 ? true : false,
                    searchableKey: obj.searchableKey ? obj.searchableKey: undefined,
                    data: obj.options,
                    renderer: (index, obj) => {
                      /*How to render dropdwon options from string of array*/
                      return <DKLabel className="" text={obj.name} />;
                    },
                    onSelect: (index, value) => {},
                  }}
                  validator={(value) => {
                    if (value && !Utility.isEmpty(value)) {
                      return true;
                    } else {
                      return false;
                    }
                  }}
                />
                {obj.hasError && (
                  <DKLabel
                    className="pt-xs pl-s fs-s unselectable text-red"
                    style={{
                      whiteSpace: "nowrap",
                    }}
                    text={obj.errMsg}
                  />
                )}
              </div>
            </div>
          );
        });
    }


    return (
      <>
        <div className="transparent-background">
          <div className="popup-window">
            <div className="row p-h-s">
              <DKLabel
                text={`${isEdit ? "Update Location" : "Add Location"}`}
                className="fs-m fw-m align-self-center width-80"
              />
              <div className="row-reverse ">
                <DKButton
                  title={`${isEdit ? "Update" : "Save"}`}
                  className="border-m ml-r bg-app text-white"
                  onClick={() => onSaveClick()}
                />
                <DKButton
                  title="Cancel"
                  className="g-gray1 border-m"
                  onClick={(event) => {
                    props.onClose();
                  }}
                />
              </div>
            </div>
            <div className="row-responsive d-flex ">
              <div className="">
                {locationColumnConfig && (
                  <div className="">
                    <div
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                      }}
                      className=" parent-width mb-s p-v-l"
                    >
                      {locationColumnConfig && getFormFields()}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </>
    );

}

export default AddEditLocation;;